import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  Button,
} from '@grupoboticario/flora-react';
import { useEffect, useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { RouterContext } from 'routes/RouterProvider';
import {
  deleteDraftAction,
  getClaimsByStatusAction,
  toggleOpenModalAction,
} from 'store/modules/claims/actions';
import { ApplicationState } from 'store/store.inteface';
import Text from 'styles/typography';
import { STATUS_OBJ } from 'utils/statusEnum';
import {
  Title,
  ModalBodyStyled,
  DraftClaim,
  DraftActions,
  DraftTitle,
  Observation,
} from './styles';

export function ModalDraft() {
  const dispatch = useDispatch();
  const history = useHistoryWithHost();
  const routes = useContext(RouterContext);
  const draftClaims = useSelector(
    (state: ApplicationState) => state.claims.drafts,
  );
  const hasDraftModalOpen = useSelector(
    (state: ApplicationState) => state.claims.hasDraftModalOpen,
  );
  const { user } = useSelector(
    (state: ApplicationState) => state.container.containerContext,
  );
  const { stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const toggleModal = useCallback(
    (open?: boolean) => dispatch(toggleOpenModalAction(open)),
    [dispatch],
  );

  useEffect(() => {
    if (stores.length > 0) {
      dispatch(
        getClaimsByStatusAction({
          status: STATUS_OBJ.Draft,
        }),
      );
    }
  }, [user, stores]);

  useEffect(() => {
    if (draftClaims.results.length > 0 && !draftClaims.responseValid) {
      dispatch(
        getClaimsByStatusAction({
          status: STATUS_OBJ.Draft,
        }),
      );
    }
  }, [draftClaims]);

  useEffect(() => {
    if (draftClaims.results.length > 0 && !routes.from.includes('openclaim')) {
      toggleModal(true);
    } else {
      toggleModal(false);
    }
  }, [draftClaims.results]);

  return (
    <Modal
      open={hasDraftModalOpen && draftClaims.results.length > 0}
      onOpenChange={() => toggleModal(false)}
    >
      <ModalContent size="standard">
        <ModalCloseButton />
        <ModalHeader />
        <ModalBodyStyled>
          <Title>
            Antes de continuar, você possui rascunhos em aberto, por gentileza,
            revise e continue o processo ou exclua o rascunho.
          </Title>
          <main>
            {draftClaims.results.map(draft => (
              <DraftClaim key={draft.number}>
                <DraftTitle>
                  <Text className="subtitle">
                    Rascunho&nbsp;
                    {draft.number}
                  </Text>
                  <Text>
                    {`${draft?.franchise?.code} - ${draft?.franchise?.name}`}
                  </Text>
                </DraftTitle>
                <DraftActions>
                  <Button
                    onClick={() => history.push(`/openclaim/${draft.id}`)}
                    styleSemantic="success"
                  >
                    Continuar
                  </Button>
                  <Button
                    onClick={() => dispatch(deleteDraftAction(draft.id))}
                    styleSemantic="warning"
                  >
                    Excluir
                  </Button>
                </DraftActions>
              </DraftClaim>
            ))}
          </main>
          <Observation>
            Observação: Só será permitido salvar dois rascunhos.
          </Observation>
        </ModalBodyStyled>
      </ModalContent>
    </Modal>
  );
}
